import { render, staticRenderFns } from "./RiderOrderDetail.vue?vue&type=template&id=2aa49927&"
import script from "./RiderOrderDetail.vue?vue&type=script&lang=js&"
export * from "./RiderOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./RiderOrderDetail.vue?vue&type=style&index=0&id=2aa49927&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports